// @flow
import type {Reducer} from '@travel-frontend/state-handling-sdk';
import type {UiState} from 'redux/uiState/UiState';

import {authReducer} from '@travel-frontend/ui-components';
import {userIdReducer} from '@travel-frontend/user-id';
import {combineReducers} from 'redux';

import {accessibilityReducer} from 'redux/uiState/accessibility/reducer';
import {availabilityReducer} from 'redux/uiState/availability/reducer';
import {insuranceReducer} from 'redux/uiState/insurance/reducer';
import {layoutReducer} from 'redux/uiState/layout/reducer';
import {leadsReducer} from 'redux/uiState/lead/reducer';
import {paymentReducer} from 'redux/uiState/payment/reducer';
import {priceoverviewReducer} from 'redux/uiState/priceoverview/reducer';
import {profileReducer} from 'redux/uiState/profile/reducer';
import {trackingReducer} from 'redux/uiState/tracking/reducer';

// $FlowIgnore
export const uiStateReducer: Reducer<UiState> = combineReducers({
  layout: layoutReducer,
  priceoverview: priceoverviewReducer,
  userId: userIdReducer,
  payment: paymentReducer,
  tracking: trackingReducer,
  insurance: insuranceReducer,
  availability: availabilityReducer,
  auth: authReducer,
  profile: profileReducer,
  accessibility: accessibilityReducer,
  leads: leadsReducer,
});
